import UserAppContext from "../../hook/UserAppContext"
import Title from '../../components/title/Title'
import Gallery from './Gallery'


const Photos = ({isCurrent, isSetObj, isSetModal}) => {

      if(isCurrent !== 'photo') return 

      const {user} = UserAppContext()
      const {galleries} = user.user 

      return (
            <div className={isCurrent === 'photo' ? "wrapper_page show" : "wrapper_page"}>
                  <div className="page_inner">
                        <Title text={`Photos`} />
                        <div className="page_gallery">
                              <Gallery galleries={galleries} isSetObj={isSetObj} isSetModal={isSetModal} />
                        </div>
                  </div>
            </div>
      )
}

export default Photos